module.exports = __webpack_public_path__ + "static/4-57434ecd15edb4692aeaf28ae6dba447.jpg";